import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HeroCarousel.css';
import img from '../Assets/img/HeroSection/hero17.jpg';
import img2 from '../Assets/img/HeroSection/hero14.jpg';
import img3 from '../Assets/img/HeroSection/hero15.jpg';
import img4 from '../Assets/img/HeroSection/hero16.jpg';
import mobileImg from '../Assets/img/HeroSection/hero11m.JPG';
import mobileImg2 from '../Assets/img/HeroSection/hero12m.JPG';
import mobileImg3 from '../Assets/img/HeroSection/hero13m.JPG';
import mobileImg4 from '../Assets/img/HeroSection/hero7m.jpg';

const CustomCarousel = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const navigate = useNavigate();

  const slides = [
    {
      title: ["Empowering Career Counsellors Nationwide"],
      description: "	Connect, Learn, and Grow together with APCCI’s Nationwide Counsellors’ Network",
      buttonText: "Join Now",
      image: img,
      mobileImage: mobileImg,
      overlayGradient: "linear-gradient(90deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%)"
    },
    {
      title: ["Where Career Counsellors Grow Together"],
      description: "Join a trusted network focused on Learning and Professional Growth",
      buttonText: "Start Your Journey ",
      image: img2,
      mobileImage: mobileImg2,
      overlayGradient: "linear-gradient(90deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%)"
    },
    {
      title: ["A Platform for Counsellors, Built by Counsellors"],
      description: "Be part of a dynamic community committed to Excellence in Career Counselling",
      buttonText: "Become a Member",
      image: img3,
      mobileImage: mobileImg3,
      overlayGradient: "linear-gradient(90deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%)"
    },
    {
      title: ["Community that not only Empowers but Supports You"],
      description: "Seek, Support & Network with the Career Counsellors across India",
      buttonText: "Join APCCI",
      image: img4,
      mobileImage: mobileImg4,
      overlayGradient: "linear-gradient(90deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%)"
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  const handleNext = () => {
    setActiveSlide((prev) => (prev + 1) % slides.length);
  };

  const handlePrev = () => {
    setActiveSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const handleTouchStart = (e) => setTouchStart(e.touches[0].clientX);
  const handleTouchMove = (e) => setTouchEnd(e.touches[0].clientX);
  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 75) handleNext();
    if (touchStart - touchEnd < -75) handlePrev();
  };

  return (
    <div
      className="hero-carousel"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-carousel-slide ${index === activeSlide ? 'active' : ''}`}
        >
          {index === activeSlide && (
            <picture>
              <source
                media="(max-width: 768px)"
                srcSet={slide.mobileImage}
              />

              <img
                src={slide.image}
                alt={slide.title.join(' ')}
                className="hero-carousel-image"
                loading="eager"
                decoding="async"
              />
            </picture>
          )}

          <div className="hero-carousel-overlay">

            {/* TOP: Title + Description */}
            <div className="hero-carousel-text-container">
              {slide.title.map((line, i) => (
                <h1 key={i} className="hero-carousel-title">
                  {line}
                </h1>
              ))}

              <p className="hero-carousel-description">
                {slide.description}
              </p>
            </div>

            {/* BOTTOM: Button */}
            <div className="hero-carousel-button-container">
              <button
                className="hero-carousel-button"
                onClick={() => navigate('/membership/plans')}
              >
                {slide.buttonText}
              </button>
            </div>

          </div>
        </div>
      ))}

      <button
        onClick={handlePrev}
        className="hero-carousel-nav-button hero-carousel-prev"
        aria-label="Previous slide"
      >
        ‹
      </button>
      <button
        onClick={handleNext}
        className="hero-carousel-nav-button hero-carousel-next"
        aria-label="Next slide"

      >
        ›
      </button>

      <div className="hero-carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setActiveSlide(index)}
            className={`hero-carousel-indicator ${index === activeSlide ? 'active' : ''}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default CustomCarousel;